import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import AbstractPoll from 'ext:fof/polls/forum/components/Poll/AbstractPoll';
import PollOption from 'ext:fof/polls/forum/components/Poll/PollOption';
import PollDraftBadges from 'ext:fof/polls/forum/components/Poll/PollDraftBadges';
import PollTranslationNotice from '../components/PollTranslationNotice';
import TranslateButton from '../components/TranslateButton';
import TranslationState from '../states/TranslationState';
import { actorTargets, isReadersLanguage } from '../utils/targets';
export default function extendPolls() {
  // Post polls render inside CommentPost's retained subtree.
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => {
      const polls = this.attrs.post.polls?.();
      return Array.isArray(polls) ? polls.map(poll => poll ? TranslationState.peek(poll)?.version ?? 0 : 0).join(',') : '';
    });
  });
  extend(AbstractPoll.prototype, 'headerItems', function (items) {
    const poll = this.attrs.poll;
    if (!poll.id()) return;

    // The backend's guess for the poll, else its post's language; a global poll may have neither.
    const source = poll.detectedLang?.() || this.state?.post?.detectedLang?.() || null;
    const targets = actorTargets();
    const available = isReadersLanguage(source) ? [] : TranslateButton.targetsFor(targets, source, TranslationState.unavailableFor(poll));
    const existing = TranslationState.peek(poll);
    if (!available.length && !existing?.showing) return;
    const state = existing ?? TranslationState.for(poll, 'polls');
    const translation = state.active();
    if (translation) {
      if (items.has('title')) {
        items.setContent('title', m("h3", {
          className: "Poll-title Poll-title--translated",
          lang: state.language ?? undefined
        }, translation.question(), m(PollDraftBadges, {
          poll: poll
        })));
      }
      const subtitle = translation.subtitle();
      if (subtitle && items.has('subtitle')) {
        items.setContent('subtitle', m("p", {
          className: "Poll-subtitle helpText Poll-subtitle--translated",
          lang: state.language ?? undefined
        }, subtitle));
      }
    }
    if (state.showing) {
      items.add('fof-translate', m(PollTranslationNotice, {
        state: state,
        source: source
      }), 10);
    } else if (available.length) {
      items.add('fof-translate', m(TranslateButton, {
        className: "Poll-translate",
        state: state,
        targets: targets,
        source: source
      }), 10);
    }
  });
  extend(PollOption.prototype, 'textItems', function (items) {
    const poll = this.attrs.state?.poll;
    const translation = poll ? TranslationState.peek(poll)?.active() : null;
    const answer = translation?.answerFor(this.attrs.option.id());
    if (answer && items.has('answer')) {
      items.setContent('answer', m("span", {
        className: "PollOption-answer PollOption-answer--translated",
        lang: translation.language()
      }, answer));
    }
  });
}
flarum.reg.add('fof-translate', 'forum/extend/extendPolls', extendPolls);